import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty, get, isEqual } from 'lodash';
import { Form } from 'semantic-ui-react';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import { getPreSignInDataAction, dispatchPreSignInData, clearPreSignInData } from '../../../actions';
import Input from '../../../components/FormElements/Input';
import routes from '../../../routes';
import './PreSignIn.scss';
import { formFields } from "./constant";
import { handleFieldError } from '../../../utils/form-validation';
import { Link } from 'react-router-dom';
import imgauth from '../../../assets/images/illustrations/auth-login-illustration-dark.png';
import imgBg from '../../../assets/images/illustrations/bg-shape-image-light.png';
import infomoImg from '../../../assets/images/bekiLogo.png';
import CryptoJS from 'crypto-js';
import { encryptAuthData } from '../../../selectors';
import { defaultPlatformConfig } from '../../../constants/configuration';

const AuthenticationCard = asyncRoute(() => import('../../../components/Card/AuthenticationCard'));
// const TextField = asyncRoute(() => import('../../../components/elements/TextField'));
const Button = asyncRoute(() => import('../../../components/elements/Button'));
const AuthenticationBody = asyncRoute(() => import('../../../components/AuthenticationBody'));
const AlertPopUp = asyncRoute(() => import('../../../components/AlertPopUp'));


class PreSignIn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formFieldsState: {
                username: '',
                password: '',
            },
            touched: {},
            errors: {},
            submited: false,
            isPreSignInDisabled: true,
            showPreSignInErrorMsg: false,
            showToast: false,
            logoImage: '',
            platformName: ''
        };
        this.handleFormFieldChange = this.handleFormFieldChange.bind(this);
        this.handlePreSignSubmit = this.handlePreSignSubmit.bind(this);
        this.handleRedirectToForgotPassword = this.handleRedirectToForgotPassword.bind(this);
        this.hanleRedirectSignup = this.hanleRedirectSignup.bind(this);
    }

    componentWillMount() {
        const { platformConfiguration } = this.props;
        let platformName = platformConfiguration['name'] ? platformConfiguration['name'] : defaultPlatformConfig['name'];
        let logoImageUrl = defaultPlatformConfig['lable']['logo'][0]['path'];
        if (platformConfiguration && platformConfiguration['lable']['logo'] && platformConfiguration['lable']['logo'].length > 0) {
            if (platformConfiguration['lable']['logo'][0].hasOwnProperty('path')) {
                logoImageUrl = platformConfiguration['lable']['logo'][0]['path'];
            }
        } else {
            logoImageUrl = defaultPlatformConfig['lable']['logo'][0]['path'];
        }
        this.setState({ logoImage: logoImageUrl, platformName });
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        if (!isEmpty(isAuthenticated)) {
            const { history } = this.props;
            history.push(routes.containers.dashboard);
        }
    }

    componentDidMount() {
        // const { clearPreSignInData } = this.props;
        // clearPreSignInData();
    }

    componentWillReceiveProps(nextProps) {
        const { history, platformConfiguration } = this.props;
        const { showPreSignInErrorMsg } = this.state;
        let currentPreSignInStatus = get(this.props, 'preSignInStatus');
        let nextPreSignInStatus = get(nextProps, 'preSignInStatus');
        let platformName = platformConfiguration['name'] ? platformConfiguration['name'] : defaultPlatformConfig['name'];
        let logoImageUrl = defaultPlatformConfig['lable']['logo'][0]['path'];
        if (platformConfiguration && platformConfiguration['lable']['logo'] && platformConfiguration['lable']['logo'].length > 0) {
            if (platformConfiguration['lable']['logo'][0].hasOwnProperty('path')) {
                logoImageUrl = platformConfiguration['lable']['logo'][0]['path'];
            }
        } else {
            logoImageUrl = defaultPlatformConfig['lable']['logo'][0]['path'];
        }
        this.setState({ logoImage: logoImageUrl, platformName });
        if (!isEmpty(nextPreSignInStatus) && !isEqual(currentPreSignInStatus, nextPreSignInStatus)) {
            if (isEqual(nextPreSignInStatus, 'Success')) {
                history.push(routes.signIn);
            }
        }
    }

    handleFormFieldChange(event) {
        const formField = { ...this.state.formFieldsState };
        const { name, value } = event.target;
        formField[name] = value;
        this.setState({
            formFieldsState: formField,
        }, () => {
            const isPreSignInDisabled = this.checkPreSignInDisabled();
            this.setState({
                isPreSignInDisabled,
            });
        });
    }

    checkPreSignInDisabled() {
        const {
            username,
            password
        } = this.state.formFieldsState;
        return (isEmpty(username)
            || isEmpty(password));
    }

    async handlePreSignSubmit(e) {
        e.preventDefault();
        const { formFieldsState } = this.state;
        let data = await encryptAuthData(formFieldsState);
        let storeData = { ...formFieldsState, password: CryptoJS.MD5(formFieldsState.password).toString() };
        const { dispatchPreSignInData, getPreSignInDataAction } = this.props;
        dispatchPreSignInData(storeData).then(() => {
            getPreSignInDataAction(data).then((res) => {
                if (res && res.responseCode && res.responseCode.status == 'Fail') {
                    this.setState({
                        showToast: true
                    }, () => {
                        // setTimeout(() => {
                        //      this.setState({ showToast: false })
                        // }, 10000)
                    });
                }

            }).catch((err) => {
                console.log(err);
            });
        });
    }

    handleRedirectToForgotPassword() {
        const { history } = this.props;
        history.push(routes.forgotPassword);
    }
    hanleRedirectSignup() {
        const { history } = this.props;
        history.push(routes.signup);
    }



    handleTouch = (e) => {
        let { touched, errors } = this.state;
        const formField = { ...this.state.formFieldsState };
        let { error } = handleFieldError(formField[e.target.name], formFields[e.target.name]);
        errors[e.target.name] = error;
        touched[e.target.name] = true;
        this.setState({ touched, errors });
    };

    handlePassword = async (e) => {
        // const {formFieldsState} = this.props
        if (formFields.password.type === 'password') {
            formFields.password.type = "text"
        } else {
            formFields.password.type = "password"
        }
        return this.setState(formFields)


    }
    toggleToast = (info) => {
        const { showToast } = this.state;
        this.setState({ showToast: !showToast })
    }

    render() {
        const { formFieldsState, isPreSignInDisabled, showPreSignInErrorMsg, touched, errors, submited, showToast, logoImage, platformName } = this.state;
        const { preSignInMsg, LoginTimer, Attempts, responseData } = this.props
        const overAllAtempts = Attempts.charAt(2)
        const inputAttempts = Attempts.charAt(0)
        const message = { action: { type: 'Error' } };


        // var givenTime = new Date(LoginTimer).getTime();
        // var currentTime = Date.now()
        // var remaningTime = givenTime - currentTime;

        // const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
        return (
            <AuthenticationBody>
                <AlertPopUp callBackToast={this.toggleToast} confirmationInfo={message} showToast={showToast} heading='Error' iconColor='red' headingColor='red'>
                    <>
                        {
                            preSignInMsg == 'User Account is Suspended. Please contact support@torcai.com' ?
                                <>
                                    <p className="errorMsg">{preSignInMsg}</p>

                                </> : responseData.hasOwnProperty('attempts') ? <p className="errorMsg">{preSignInMsg}. You have made {inputAttempts} unsuccessful attempt(s) out of {overAllAtempts} allowed attempts.</p> :

                                    <p className="errorMsg">{preSignInMsg}</p>
                        }
                    </>
                </AlertPopUp>

                <div class="d-none d-lg-flex col-lg-7 p-0">
                    <div class="auth-cover-bg auth-cover-bg-color d-flex justify-content-center align-items-center">
                        <img
                            src={imgauth}
                            alt="auth-login-cover"
                            class="img-fluid my-5 auth-illustration"
                            data-app-light-img="illustrations/auth-login-illustration-light.png"
                            data-app-dark-img="illustrations/auth-login-illustration-dark.png"
                        />

                        <img
                            src={imgBg}
                            alt="auth-login-cover"
                            class="platform-bg"
                            data-app-light-img="illustrations/bg-shape-image-light.png"
                            data-app-dark-img="illustrations/bg-shape-image-dark.png"
                        />
                    </div>
                </div>


                <div class="d-flex col-12 col-lg-5 align-items-center p-sm-5 p-4">
                    <div class="w-px-400 mx-auto">
                        <div class="app-brand mb-4">
                            <a href="#" class="app-brand-link gap-2">
                                <img style={{ width: '30%' }} src={logoImage} />
                            </a>
                        </div>
                        <h3 class="mb-1 fw-bold">Welcome to {platformName.toLowerCase()}! 👋</h3>
                        <p class="mb-4">Please sign-in to your account and start the adventure</p>

                        <form id="formAuthentication" class="mb-3" onSubmit={this.handlePreSignSubmit}>
                            <div class="mb-3">
                                <Input
                                    onChange={this.handleFormFieldChange}
                                    onBlur={this.handleTouch}
                                    value={formFieldsState.username}
                                    setting={formFields[formFields.username.key]}
                                    error={errors[formFields.username.key]}
                                    submited={submited}
                                    touched={touched[formFields.username.key]}
                                />
                            </div>
                            <div class="mb-3 form-password-toggle">
                                <div style={{ position: 'relative' }}>
                                    <Input
                                        onChange={this.handleFormFieldChange}
                                        onBlur={this.handleTouch}
                                        value={formFieldsState.password}
                                        setting={formFields[formFields.password.key]}
                                        error={errors[formFields.password.key]}
                                        submited={submited}
                                        touched={touched[formFields.password.key]}
                                    />
                                    <i style={{ position: 'absolute', top: 42, right: 15 }} onClick={this.handlePassword} class={`ti ${formFields.password.type == "password" ? "ti-eye-off" : "ti-eye"} cursor-pointer`}>
                                    </i>
                                </div>
                            </div>
                            <button disabled={isPreSignInDisabled} class="btn btn-primary d-grid w-100  heightBtn36 mb-2">Login</button>
                            <div class="d-flex justify-content-end">
                                <a href="#" onClick={this.handleRedirectToForgotPassword}>
                                    <small>Forgot Password?</small>
                                </a>
                            </div>
                        </form>

                        {/* <p class="text-center">
                            <span>New on our platform?</span>
                            <a href="#">
                                <span onClick={this.hanleRedirectSignup} > Create an account</span>
                            </a>
                        </p> */}

                        {/* code for new plat ****************************************** */}

                        {/* <div class="divider">
                            <div class="divider-text">or</div>
                        </div>

                        <p class="text-center">
                            <span>New on our platform?</span>
                            <a href="#">
                                <span onClick={this.hanleRedirectSignup} > Create an account</span>
                            </a>
                        </p> */}

                        {/* ************************************ */}

                        {/* <div class="d-flex justify-content-center">
                            <a href="javascript:;" class="btn btn-icon btn-label-facebook me-3">
                                <i class="tf-icons fa-brands fa-facebook-f fs-5"></i>
                            </a>

                            <a href="javascript:;" class="btn btn-icon btn-label-google-plus me-3">
                                <i class="tf-icons fa-brands fa-google fs-5"></i>
                            </a>

                            <a href="javascript:;" class="btn btn-icon btn-label-twitter">
                                <i class="tf-icons fa-brands fa-twitter fs-5"></i>
                            </a>
                        </div> */}

                    </div>
                </div >

            </AuthenticationBody >
        );
    }
}


export default connect(
    state => ({
        preSignInStatus: get(state, 'app.preSignInData.responseCode.status', ''),
        preSignInMsg: get(state, 'app.preSignInData.responseCode.msg', ''),
        LoginTimer: get(state, 'app.preSignInData.response.endDate', ''),
        Attempts: get(state, 'app.preSignInData.response.attempts', ''),
        responseData: get(state, 'app.preSignInData.response', ''),
        platformConfiguration: get(state, 'app.platformConfiguration', '')

    }),
    {
        getPreSignInDataAction,
        dispatchPreSignInData,
        clearPreSignInData
    }
)(PreSignIn);